var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6258_2128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.83856 52.3835L7.66104 57.2587C8.24751 58.285 9.09055 59.0915 10.0803 59.6779C12.9151 56.0796 14.8884 53.3182 16.0002 51.3938C17.1284 49.4409 18.5152 46.3863 20.1606 42.2299C15.7266 41.6463 12.3665 41.3545 10.0803 41.3545C7.88637 41.3545 4.52628 41.6463 0 42.2299C0 43.3662 0.293247 44.5026 0.879734 45.5289L4.83856 52.3835Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9203 59.6779C54.9101 59.0915 55.7531 58.285 56.3396 57.2587L57.5126 55.2427L63.1209 45.5289C63.7073 44.5026 64.0006 43.3662 64.0006 42.2299C59.4481 41.6463 56.0941 41.3545 53.9387 41.3545C51.6222 41.3545 48.2682 41.6463 43.8767 42.2299C45.5026 46.409 46.8711 49.4636 47.9821 51.3938C49.103 53.341 51.0824 56.1024 53.9203 59.6779Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 21.7028C35.2803 17.7414 37.5407 14.6867 38.7816 12.5389C39.7808 10.8094 40.8804 8.04802 42.0806 4.25473C41.0908 3.66824 39.9545 3.375 38.7816 3.375H25.219C24.046 3.375 22.9097 3.7049 21.92 4.25473C23.4465 8.60525 24.7419 11.7015 25.806 13.5433C26.982 15.5788 29.0467 18.2986 32.0003 21.7028Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.84 42.2299H20.1605L10.0803 59.6779C11.07 60.2645 12.2063 60.5577 13.3793 60.5577H50.6213C51.7943 60.5577 52.9306 60.2278 53.9203 59.6779L43.84 42.2299Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 21.7028L21.9201 4.25473C20.9303 4.84122 20.0872 5.64761 19.5008 6.67401L0.879734 38.9309C0.293247 39.9573 0 41.0936 0 42.2299H20.1606L32.0003 21.7028Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8104 22.8025L44.4999 6.67401C43.9134 5.64761 43.0703 4.84122 42.0806 4.25473L32.0003 21.7028L43.84 42.2299H63.964C63.964 41.0936 63.6707 39.9573 63.0843 38.9309L53.8104 22.8025Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6258_2128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google-drive.95f4a1bd1276c2ce6f69f37f0b41c453.svg";
export { ForwardRef as ReactComponent };